"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACAutoCompleteInputWithButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var antd_1 = require("antd");
var truncateTextByWords = function (text, wordLimit) {
    var wordsArray = text.split(' '); // Split the text into words
    if (wordsArray.length <= wordLimit) {
        return text; // If the number of words is less than or equal to the limit, return the original text
    }
    return wordsArray.slice(0, wordLimit).join(' ') + '...'; // Truncate and add ellipsis
};
var renderItem = function (item, wordLimit) {
    if (wordLimit === void 0) { wordLimit = 18; }
    var label = item.label, contact = item.contact, index = item.index;
    var truncatedLabel = label ? truncateTextByWords(label, wordLimit) : '';
    return __assign(__assign({}, item), { key: item._id || '', value: item._id || '', labelText: label || ' ', valueText: contact || '', label: ((0, jsx_runtime_1.jsxs)(antd_1.Flex, { align: "center", justify: "space-between", children: [contact, (0, jsx_runtime_1.jsx)(antd_1.Typography.Text, { ellipsis: true, children: truncatedLabel })] })) });
};
var ACAutoCompleteInputWithButton = function (props) {
    var _a;
    var _b = (0, react_1.useState)(props.items && ((_a = props.items) === null || _a === void 0 ? void 0 : _a.map(function (item) { return renderItem(item); }))), allOptions = _b[0], setAllOptions = _b[1];
    var _c = (0, react_1.useState)(props.items && props.items.map(function (item) { return renderItem(item); })), options = _c[0], setOptions = _c[1];
    var _d = (0, react_1.useState)(), value = _d[0], setValue = _d[1];
    var _e = (0, react_1.useState)(''), searchText = _e[0], setSearchText = _e[1];
    var _f = (0, react_1.useState)(''), debouncedSearchText = _f[0], setDebouncedSearchText = _f[1];
    var _g = (0, react_1.useState)(false), dropdownVisible = _g[0], setDropdownVisible = _g[1];
    // Effect to set options when items change or search text changes (static code: patient_search)
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (props.items) {
            var mobile_number = (_e = (_d = (_c = (_a = props.context.state.dynamic) === null || _a === void 0 ? void 0 : _a[(_b = props.context) === null || _b === void 0 ? void 0 : _b.rootState]) === null || _c === void 0 ? void 0 : _c[(props === null || props === void 0 ? void 0 : props.name) || '']) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e['key'];
            var newOptions = props.items.map(function (item) { return renderItem(item); });
            setAllOptions(newOptions);
            if ((newOptions === null || newOptions === void 0 ? void 0 : newOptions.length) === 0 || (!newOptions && (props === null || props === void 0 ? void 0 : props.items))) {
                // console.log('entered the block1');
                if (((_f = props.items) === null || _f === void 0 ? void 0 : _f.length) === 0) {
                    // console.log('entered the block2');
                    // console.log('props.value', props.value);
                    if (props.value && ((_g = props.value.value) === null || _g === void 0 ? void 0 : _g.length) === 10) {
                        // console.log('entered the block3');
                        setDropdownVisible(true);
                        newOptions.push({
                            key: 'Add patient',
                            label: '',
                            value: 'Add patient',
                            labelText: '',
                            valueText: '',
                        });
                    }
                }
            }
            setOptions(newOptions);
            // console.log('newOptions', options);
            // Show dropdown when we have items
            if (newOptions && newOptions.length > 0 && searchText) {
                setDropdownVisible(true);
            }
        }
    }, [props.items, searchText]);
    // Effect to set the value when props.value changes
    (0, react_1.useEffect)(function () {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);
    // Effect for debouncing the search text
    (0, react_1.useEffect)(function () {
        var handler = setTimeout(function () {
            setDebouncedSearchText(searchText);
        }, 300); // Set delay in milliseconds
        // Cleanup function to clear the timeout if searchText changes
        return function () {
            clearTimeout(handler);
        };
    }, [searchText]);
    // Effect to filter options based on the debounced search text
    // useEffect(() => {
    //   if (debouncedSearchText) {
    //     const filteredOptions =
    //       allOptions &&
    //       allOptions.filter((option: OptionType) =>
    //         option.valueText
    //           .toLowerCase()
    //           .includes(debouncedSearchText.toLowerCase()),
    //       );
    //     setOptions(filteredOptions);
    //   } else {
    //     setOptions(allOptions); // Reset options if search text is empty
    //   }
    // }, [debouncedSearchText, allOptions]);
    var handleChange = function (value) {
        // Allow numeric input without length restriction
        if (!/^\d*$/.test(value))
            return;
        setSearchText(value);
        var newOption = { key: value, value: value };
        setValue(newOption);
        if (props.onChange) {
            props.onChange(newOption);
        }
    };
    // static code: form_visibility
    var onSearch = function (searchText) {
        var _a, _b, _c, _d;
        // console.log(
        //   'state in block',
        //   props?.context.state?.dynamic[props?.context.rootState],
        // );
        if (((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[props === null || props === void 0 ? void 0 : props.context.rootState]) === null || _c === void 0 ? void 0 : _c['form_visibility']) === 'block') {
            props === null || props === void 0 ? void 0 : props.context.dispatch((_d = props === null || props === void 0 ? void 0 : props.context) === null || _d === void 0 ? void 0 : _d.setStateValue({
                path: "".concat(props === null || props === void 0 ? void 0 : props.context.rootState, ".form_visibility"),
                value: 'none',
            }));
        }
        // Remove the length restriction to allow searching with fewer digits
        if (/^\d+$/.test(searchText)) {
            setSearchText(searchText);
            setDropdownVisible(true);
        }
        else if (!searchText) {
            setSearchText('');
            setDropdownVisible(false);
            props.onSelect({});
        }
    };
    var onSelect = function (value, option) {
        var _a;
        // console.log(174, value, option);
        if (props.onSelect) {
            var newOption = __assign(__assign({}, option), { key: option.key, value: option.valueText, text: option.labelText });
            // console.log('selected option', newOption);
            if (newOption.key === 'Add patient') {
                // console.log('entered the block4', props?.context.rootState);
                props === null || props === void 0 ? void 0 : props.context.dispatch((_a = props === null || props === void 0 ? void 0 : props.context) === null || _a === void 0 ? void 0 : _a.setStateValue({
                    path: "".concat(props === null || props === void 0 ? void 0 : props.context.rootState, ".form_visibility"),
                    value: 'block',
                }));
            }
            props.onSelect(newOption);
        }
        setDropdownVisible(false);
        // console.log('Selected value:', value, option);
    };
    // console.log('options', options);
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.containerClassName, children: [props.label && ((0, jsx_runtime_1.jsxs)("p", { className: props.labelClassName, children: [props.label, ' ', props.required ? (0, jsx_runtime_1.jsx)("span", { style: { color: 'red' }, children: "*" }) : ''] })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(antd_1.AutoComplete, { placeholder: props.placeholder, allowClear: props.allowClear, id: props.name, options: options, disabled: props.disabled, status: props.required && props.errorText ? 'error' : '', className: "".concat('apx-ui_select', " ").concat((props === null || props === void 0 ? void 0 : props.color) || 'primary', " ").concat(props.className), onChange: handleChange, onSearch: onSearch, onSelect: onSelect, value: value === null || value === void 0 ? void 0 : value.value, open: dropdownVisible && options && options.length > 0, onBlur: function () { return setTimeout(function () { return setDropdownVisible(false); }, 200); }, onFocus: function () {
                        return searchText &&
                            options &&
                            options.length > 0 &&
                            setDropdownVisible(true);
                    } }) }), props.required ? ((0, jsx_runtime_1.jsx)("p", { className: props.errorClassName, children: props.errorText && props.errorText })) : null] }));
};
exports.ACAutoCompleteInputWithButton = ACAutoCompleteInputWithButton;
